import { TRootState } from '../@types/redux'

export const selectModalUser = (state: TRootState) => state.users.userModalIsOpen

export const selectIsUpdateUser = (state: TRootState) => state.users.isUpdateUser

export const selectUserForUpdate = (state: TRootState) => state.users.userForUpdate

export const selectUserRefreshTable = (state: TRootState) => state.users.refreshTableUsers